import { ROUTE_GET_SYNTHESES } from '@/constants';
import Synthesis from '@/classes/Synthesis';
import SynthesisValidator from '@/validators/SynthesisValidator';
import axios from 'axios';

export const getSynthesesRequest = async (): Promise<Synthesis[]> => {
  const serializedSyntheses: Synthesis[] = (await axios.get(ROUTE_GET_SYNTHESES)).data
  SynthesisValidator.validateSynthesis(serializedSyntheses)
  return serializedSyntheses as Synthesis[]
}